import $ from 'jquery';
(<any>window).$ = $;
(<any>window).jQuery = $;

import { Peeky } from '@front/peeky/peeky';
let pk = new Peeky();
(<any>window).pk = pk;
(<any>window).Peeky = Peeky;

import { PeekyImage } from '@front/peeky/peeky.image';
import { Grid } from '@front/grid';
import { Waiter } from '@shared/waiter';
import { throttle } from '@shared/throttle';
import { PeekyVideo } from 'peeky/peeky.video';
import { transitionend } from '@front/dom';
import { FocusObserver } from '@front/dom/FocusObserver';

import * as Map from './_ts/map';
import { requestAnimationFramePromise } from '@shared/requestanimationframepromise';
import { PeekyElement } from 'peeky/peeky.element';
import { PeekyState } from 'peeky/peeky.state';

const $window = $(window);
const $document = $(document);
const $body = $('body');

pk.interactor('a:not(.custom,.noscroll),.a:not(.custom,.noscroll)', { popupRemote: true, scrollTo: false, activateSelector: 'nav a:not(.custom,.noscroll)', preloadOn: 'hoverIntent'});
pk.interactor('form:not(.custom)', { reload: 'all', scrollTo: false, popupRemote: true, activateSelector: 'nav a:not(.custom,.noscroll)' });

// This needs to happen before image loading, as image resolutions is based on grid items sizes
pk.on('loadedState', function(param, state: PeekyState) {

  state.$find('.grid').each(function() {
    let gridDOM = this;
		let $grid = $(gridDOM);
		let grid = new Grid(pk, gridDOM);
		$grid.data('grid', grid);

		let resize = (e) => {
			if (e && e.type === 'gridResize') {
				return;
			}
			grid.resize();
		};

		let toggleClass = (e) => {
			let mutated = grid.mutateState(grid.parseDomData());
			if (mutated) {
				grid.render();
			}
		};

		let updateGridBrowse = () => {
			if ((grid._state.startNo || 0) === 0) {
				$grid.addClass('atFirst');
			} else {
				$grid.removeClass('atFirst');
			}
			let currentPosition = grid._currentLayout;
			if (!currentPosition) {
				return;
			}
			let startNo = grid._state.startNo ?? 0;
			let startLeft = currentPosition.itemList[startNo]?.css?.left ?? 0;
			let visibleRight = startLeft + grid._state.containerWidth;
			let isAtLast = true;
			for (let i=0; i<currentPosition.itemList.length; i++) {
				let item = currentPosition.itemList[i];
				if ((item.css?.left || 0) + (item.css?.width || 0) > visibleRight) {
					isAtLast = false;
				}
			}
			if (isAtLast) {
				$grid.addClass('atLast');
			} else {
				$grid.removeClass('atLast');
			}
		}

		// Preload next/previous for slideshows
		grid.on('rendered', function(state) {
			if (state.gridder === 'slideshow') {
				let startNo = this._state.startNo || 0;
				let previous = (this.items.length - startNo - 1) % this.items.length;
				let next = (this.items.length + startNo + 1) % this.items.length;
				let previousImage = this.items[previous]?.querySelectorAll('.peekyImage,.peekyVideo');
				let nextImage = this.items[next]?.querySelectorAll('.peekyImage,.peekyVideo');
				for (let i=0; i<previousImage?.length; i++) {
					previousImage[i].dispatchEvent(new Event('preload'));
				}
				for (let i=0; i<nextImage?.length; i++) {
					nextImage[i].dispatchEvent(new Event('preload'));
				}
			}
		});

		let skip = (offset) => {
			let startNo = grid._state.startNo || 0;
			let newNo = startNo + offset;
			if (newNo >= grid.items.length || newNo < 0) {
				if ($grid.data('gridslideloop') === 'loop') {
					newNo = ((newNo % grid.items.length) + grid.items.length) % grid.items.length;
				} else {
					// Go to next project?
					return;
				}
			}
			grid.render({ startNo: newNo }, { animate: true });
			grid.mutateState({ startNo: newNo });
			updateGridBrowse();
		}

		$grid.on('click', '.gridBrowse .previous', function() {
			skip(-1);
		});
		$grid.on('click', '.gridBrowse .next', function() {
			skip(1);
		});

		$grid.on('reloadGrid', throttle(() => {
			grid.reload();
			grid.resize();
		}));

		state.one('attached', function() {
			grid.updateItems();
		})
    state.on('attached', function() {
			grid.resize();
			pk.on('resize', resize);
			pk.on('toggleClass', toggleClass);
			$window.on('updateGrid', throttle(resize));
			$grid.on('updateGrid', throttle(resize));
			updateGridBrowse();
      let parentWindow = <any>window.parent;
			if (parentWindow && parentWindow.pk) {
				var $cmsGrid = parentWindow.$($grid[0]);
				$cmsGrid.on('updatedGrid', throttle(resize));
			}
		});
		state.one('attached', function() {
			if (grid.items) {
        $(grid.items).addClass('gridded');
			}
		});
		
		state.on('detached', function() {
			grid.reset();
			pk.off('resize', resize);
			pk.off('toggleClass', toggleClass);
			$window.off('updateGrid', resize);
			$grid.off('updateGrid', throttle(resize));
      let parentWindow = <any>window.parent;
			if (parentWindow && parentWindow.pk) {
				var $cmsGrid = parentWindow.$($grid[0]);
				$cmsGrid.off('toggleClass', resize);
				$cmsGrid.off('updatedGrid', resize);
			}
		});
  });
});


// Initialize images
pk.on('loadedState', function(param, state) {
	state.$find('[data-image]').each(function() {
    let image = <HTMLImageElement>this;
		let peekyImage = new PeekyImage(image, pk);
		let focusObserver = new FocusObserver(image, { margin: 400 });

		focusObserver.onFocus(() => {
			peekyImage.focusIn();
		});
		focusObserver.onFocusOut(() => {
			peekyImage.focusOut();
		});

		state.attached(async () => {
			let grid = $(image).closest('.grid').data('grid');
			if (grid) {
				await grid.ready();
			}
			focusObserver.activate();
		});
		state.detached(() => {
			focusObserver.deactivate();
		});

		image.addEventListener('preload', () => {
			peekyImage.load();
		});
		image.addEventListener('pk-loaded', () => {
			image.classList.add('loaded');
		}, {
			once: true
		});

	});
});

// Initialize videos
pk.on('loadedState', function(param, state) {
	state.$find('[data-video]').each(function() {
    const video = <HTMLVideoElement>this;
		const peekyVideo = new PeekyVideo(video, pk);
		let focusObserver = new FocusObserver(video, { margin: 400 });

		focusObserver.onFocus(() => {
			peekyVideo.focusIn();
		});
		focusObserver.onFocusOut(() => {
			peekyVideo.focusOut();
		});

		state.attached(async () => {
			let grid = $(video).closest('.grid').data('grid');
			if (grid) {
				await grid.ready();
			}
			focusObserver.activate();
		});
		state.detached(() => {
			focusObserver.deactivate();
		});
		
		video.addEventListener('pk-loaded', () => {
			video.classList.add('loaded');
		}, {
			once: true
		});

	});
});



// Update site title on navigation
(function() {
	var urlIndex = {};
	var siteTitle: string;

	function urlWithDefaults(url) {
		return pk.paramToUrl(pk.urlToParam(url, false, true));
	}

	pk.one('pushState', function(param) {
		var fullTitle = document.title + '';
		var splitTitle = fullTitle.split(/ - /);
		var pageTitle;
		if (typeof(splitTitle[1]) === 'undefined') {
			siteTitle = splitTitle[0];
		} else {
			siteTitle = splitTitle[1];
			pageTitle = splitTitle[0];
		}

		var $inverter = $('#inverter');
		var _idArr;
		var _subArr;
		if ($inverter.length > 0) {
			_idArr = $inverter[0].className.match(/at-([a-zA-Z0-9]+)/gi) || [];
			_idArr = _idArr.map(function(value) {
				return value.substr(3);
			});
			_subArr = $inverter[0].className.match(/sub-([a-zA-Z0-9]+)/gi) || [];
			_subArr = _subArr.map(function(value) {
				return value.substr(4);
			});
		}

		urlIndex[urlWithDefaults(param.location.url)] = { var: { metaTitle: pageTitle, _idArr: _idArr, _subArr: _subArr } };
	});

	pk.on('postLoad', function(param) {
		if (param.metadata) {
			urlIndex[urlWithDefaults(param.location.url)] = param.metadata;
		}
	});

	pk.on('switchSync', function(param, bubbled) {
		if (bubbled) {
			return;
		}
		// When all elements has triggered 'switchState', animateOut is done
		var metadata = urlIndex[urlWithDefaults(param.location.url)];
		var $inverter = $('#inverter');
		var inverter = $inverter[0];
		if (inverter && metadata && metadata.var) {
			inverter.className = inverter.className.replace(/at-[0-9]+/gi, '');
			if (metadata.var._idArr) {
				for (var i=0; i<metadata.var._idArr.length; i++) {
					$inverter.addClass('at-' + metadata.var._idArr[i]);
				}
			}
			inverter.className = inverter.className.replace(/sub-[0-9]+/gi, '');
			if (metadata.var._subArr) {
				for (var i=0; i<metadata.var._subArr.length; i++) {
					$inverter.addClass('sub-' + metadata.var._subArr[i]);
				}
			}
		}
	});

	pk.on('pushState', function(param) {
		var metadata = urlIndex[urlWithDefaults(param.location.url)];
		// Title
		if (metadata && metadata.var && metadata.var.metaTitle) {
			if (siteTitle) {
				document.title = metadata.var.metaTitle + ' - ' + siteTitle;
			} else {
				document.title = metadata.var.metaTitle;
			}
		} else {
			document.title = siteTitle;
		}
	});
})();


// Adaptive menu underline 
pk.on('loadedState', function(param, state) {
	state.$find('nav .activeBar').each(function() {
		var $bar = $(this);
		var $nav = $bar.closest('nav');
		var $active;
		$bar.css('display', 'none');

		function moveBar($target) {
			var left;
			var top;
			var targetWidth;
			var isHidden = $bar.width() <= 0;
			var currentTop = parseFloat($bar.css('top') || '0');

			if ($bar.css('display') === 'none') {
				return;
			}

			// Move to an existing target
			if ($target && $target.length > 0) {
				left = $target.position().left + parseFloat($target.css('paddingLeft'));
				top = $target.position().top + $target.outerHeight() - $bar.height();
				targetWidth = $target.width();
			}
			// Target doesn't exist, it should slide to nothing
			else {
				targetWidth = 0;
				left = parseFloat($bar.css('left')) + ($bar.width() / 2);
				top = currentTop;
			}
			// If height is different (more than 10 px), create a clone
			if (!isHidden && (Math.abs(currentTop-top) > 10)) {
				var cachedTransitionDuration = $bar.css('transition-duration');
				var barWidth = $bar.width();
				var barLeft = parseFloat($bar.css('left'));
				var $clone = $bar.clone();
				$bar.after($clone);
        transitionend($clone[0], () => {
					$clone.remove();
        });
				$clone.css({
					width: 0,
					left: barLeft + barWidth/2 // Replace targetwidth/left with currentwidth/left
				});
				$bar.css('transition-duration', '0s');
				$bar.css({
					width: 0,
					left: left + targetWidth/2,
					top: top
				});
				$bar.width(); // Trigger repaint
				$bar.css('transition-duration', cachedTransitionDuration);
			}
			else if (isHidden) {
				var cachedTransitionDuration = $bar.css('transition-duration');
				$bar.css('transition-duration', '0s');
				$bar.css({
					left: left + targetWidth/2,
					top: top
				});
				$bar.width(); // Trigger repaint
				$bar.css('transition-duration', cachedTransitionDuration);
			} else {
				$bar.css('transition-duration', '');
			}
			$bar.css({
				left: left,
				top: top,
				width: targetWidth
			});
		};
		function setActive(e) {
			$active = $nav.find('a._active');
			moveBar($active);
		};
		function onHoverIn(e) {
			moveBar($(this));
		};
		function onHoverOut(e) {
			$active = $nav.find('a._active');
			moveBar($active);
		};
		function showBar() {
			$bar.css('display', 'block');
		};

		state.on('attached', function(p, state) {
			pk.on('resize', setActive);
			pk.on('postPushState', setActive);
			pk.on('showMenu', setActive);
			pk.one('postPushState', showBar);
			$nav.on('mouseenter', 'a', onHoverIn);
			$nav.on('mouseleave', 'a', onHoverOut);
		});
		state.on('detached', function() {
			pk.off('resize', setActive);
			pk.off('postPushState', setActive);
			pk.off('showMenu', setActive);
			pk.off('postPushState', showBar);
			$nav.off('mouseenter', 'a', onHoverIn);
			$nav.off('mouseleave', 'a', onHoverOut);
			$bar.css('display', 'none');
		})
	});
});



pk.on('loadedElement', function(param, element) {
	if (element.key === '_kk' || element.key === '_pre') {
		return;
	}

	async function preSwitchState(this: PeekyElement, param) {
		const $attach: JQuery = param.$attach;
		const $detach: JQuery = param.$detach;
		$attach.addClass('pk-switchIn');
		$attach.addClass('pk-switchInInit');

		if ($detach) {
			await requestAnimationFramePromise(2);
			await transitionend($detach[0]);
		}
	}

	async function postSwitchState(this: PeekyElement, param) {
		element.unbindAction('cancelSwitchState', cancelSwitchState);

		const $attach: JQuery = param.$attach;
		const $detach: JQuery = param.$detach;
		
		// Wait for switchIn animation to end
		await requestAnimationFramePromise(2);
		if ($detach) {
			$detach.removeClass('pk-switchOut'); // param.$detach should be hidden at this point
		}
		$attach.width();
		$attach.removeClass('pk-switchInInit');
		await transitionend($attach[0]);
		element.$dom.removeClass('pk-loading');
		$attach.removeClass('pk-switchIn');
	};

	async function cancelSwitchState(this: PeekyElement, param) {
		const state = element.state();
		element.$dom.removeClass('pk-loading');
		state.$dom.removeClass('pk-switchOut');

		const $attach: JQuery = param.$attach;
		$attach.removeClass('pk-switchIn');
		$attach.removeClass('pk-switchInInit');

		element.unbindAction('preSwitchState', preSwitchState);
		element.unbindAction('postSwitchState', postSwitchState);
	}

	// Mark current states as switching out
	element.bindAction('prepareSwitchState', async function(this: PeekyElement, param) {
		if (param.child) {
			return;
		}
		const state = element.state();
		element.$dom.addClass('pk-loading');
		state.$dom.addClass('pk-switchOut');
		state.$dom.addClass('pk-switchOutInit');

		// Avoid double binding
		element.unbindAction('preSwitchState', preSwitchState);
		element.unbindAction('postSwitchState', postSwitchState);
		element.unbindAction('cancelSwitchState', cancelSwitchState);
		element.oneAction('preSwitchState', preSwitchState);
		element.oneAction('postSwitchState', postSwitchState);
		element.oneAction('cancelSwitchState', cancelSwitchState);

		await requestAnimationFramePromise();
		state.$dom.removeClass('pk-switchOutInit');
	});
});

pk.on('postPrepareSwitch', function(param) {
	const waiter = new Waiter('switchStateSync');

	waiter.add(); // done() is called for the pk.switchstate event
	let switchElements: { [key: string]: PeekyElement } = { ...param.switchElementRoots }; // Create a clone, in case it is modified elsewhere
	for (let elementKey in switchElements) {
		let switchElement = switchElements[elementKey];
		let switchOutState = switchElement.state();
		switchElement.oneAction('preSwitchState', onPreSwitchState);
		switchElement.oneAction('cancelSwitchState', onCancelSwitchState);
		switchElement.oneAction('postSwitchState', onPostSwitchState);
		switchOutState.$dom.addClass('pk-switchOutSync');
		switchOutState.$dom.addClass('pk-switchOutInitSync');
		switchOutState.$dom.width();
		switchOutState.$dom.removeClass('pk-switchOutInitSync');
		switchElement.triggerAction('initSwitchSync', param);
		waiter.add(elementKey);
	}

	async function onCancelSwitchState(param) {
		const element: PeekyElement = this;
		element.unbindAction('preSwitchState', onPreSwitchState);
		element.state().$dom.removeClass('pk-switchOutSync');
		element.triggerAction('cancelSwitchSync', param);
		waiter.done(element.key);
	}

	// $attach and $detach are ready, $attach is hidden, $detach is visible
	async function onPreSwitchState(param) {
		const element: PeekyElement = this;
		element.unbindAction('cancelSwitchState', onCancelSwitchState);
		waiter.done(element.key, function() {
			const $attach = param.$attach;
			$attach.addClass('pk-switchInSync');
			$attach.addClass('pk-switchInInitSync');
			element.triggerAction('switchSync', param);
		});
	}

	// $attach is visible, $detach is detached
	async function onPostSwitchState(param) {
		const $attach: JQuery = param.$attach;
		const $detach: JQuery = param.$detach;
		if ($detach) {
			$detach.removeClass('pk-switchOutSync'); // param.$detach should be hidden at this point
		}
		$attach.width();
		$attach.removeClass('pk-switchInInitSync');
		await transitionend($attach[0]);
		$attach.removeClass('pk-switchInSync');
	};

	pk.triggerAction('initSwitchSync', param);
	waiter.done(function() {
		pk.triggerAction('switchSync', param);
	});
});



pk.on('prepareSwitch', function(param) {
	pk.triggerAction('site-loading', param);
	pk.one('switched', function(param) {
		pk.triggerAction('site-loaded', param);
	});
});


$body.on('mouseenter', '.previousNext a', function(e) {
	var $a = $(this);
	var $previousNext = $a.closest('.previousNext');
	var $entered = $previousNext.data('$entered');

	if (!$entered) {
		$entered = $a;
		$previousNext.data('$entered', $entered);
		$previousNext.one('mouseleave', function() {
			$entered = $previousNext.data('$entered');
			$entered.trigger('leave');
			$previousNext.removeData('$entered');
		});
	}

	function leave() {
		$entered = $entered.remove($a);
		$previousNext.data('$entered', $entered);
	};
	$a.one('leave', leave);

	// Check if there are elements in $entered that can be collapsed without affecting positions
	$entered.not($a).each(function() {
		var $entry = $(this);
		if ($entry) {
			$entry.trigger('leave');
		}
	});


});


// Dropdown navigation
(function() {
	$body.on('click', '.dropnav', function() {
		var $nav = $('.topnav').add(this);
		
		function open() {
			$nav.addClass('opening');
			$body.addClass('topnavOpening');
			$nav.removeClass('closed');
			$body.removeClass('topnavClosed');
			$nav.width();
			$nav.addClass('open');
			$body.addClass('topnavOpen');
			$nav.removeClass('opening');
			$body.removeClass('topnavOpening');
			transitionend($nav[0], function() {
				// Opened
			});
			pk.trigger('showMenu');
			pk.one('preGoTo', close);
			$window.one('scroll', close);
		}

		function close() {
			if ($nav.is('.closed,.closing,.opening')) {
				return;
			}
			$nav.addClass('closing');
			$body.addClass('topnavClosing');
			$nav.width();
			$nav.addClass('closed');
			$body.addClass('topnavClosed');
			$nav.removeClass('open');
			$body.removeClass('topnavOpen');
			transitionend($nav.filter('.topnav')[0], function() {
				$nav.removeClass('closing');
				$body.removeClass('topnavClosing');
			});
			pk.off('preGoTo', close);
		};

		if ($nav.is('.open')) {
			close();
		} else {
			if ($nav.is('.closing,.opening')) {
				return;
			}
			open();
		}
	});
})();


// Scrolled to bottom class
// At top class
// ScrolledUp / ScrolledDown classes
(function() {
	var startScroll;
	var scrollTimer;
	var timerUpDelta = -75;
	var timerDownDelta = 120;
	function timerFunc() {
		scrollTimer = undefined;
		startScroll = undefined;
	}
	
	function check() {
		var scrollTop = $window.scrollTop();
		if (!scrollTimer) {
			scrollTimer = setTimeout(timerFunc, 200);
			startScroll = scrollTop;
		} else {
			if (scrollTop-startScroll < timerUpDelta) {
				$body.removeClass('scrolledDown');
				$body.addClass('scrolledUp');
			}
			if (scrollTop-startScroll > timerDownDelta) {
				$body.removeClass('scrolledUp');
				$body.addClass('scrolledDown');
			}
		}
	};
	$window.on('scroll', throttle(check, 100));
	pk.on('postPushState', check);
})();


// Scroll page on navigation. scrollTop()
pk.on('loadedElement', function(param, element) {
	var $winscroll = $('body,html');
	// Switch a main section
	if (element.key === 's') {
		element.on('prepareSwitchState', function(param, target) {
			var subElement = param.state.element;
			if (subElement.parent !== element) {
				return;
			}
			var newRootArguments = param.location.param._kk._arg || {};
			var catchPathLevel = subElement.pathLevel()-1; // Represents 1-indexed last path catched by this element
			var subPath = newRootArguments[catchPathLevel];
			if (typeof(subPath) === 'undefined') {
				// Animate whatever
			} else {
				// Animate wh00tever
			}
		});
		element.on('switchState', function(param) {
			if (typeof(param.options.scrollTop) === 'undefined') {
				$winscroll.stop().scrollTop(0);
			}
		});
	}
	// Switch a sub section
	else if (element.key === 'w') {
		element.on('switchState', function(param) {
			if (typeof(param.options.scrollTop) === 'undefined') {
				$winscroll.stop().scrollTop(0);
			}
		});
	}
});



// Show/hide subnav
pk.on('loadedState', function(param, state) {
	state.$find('.subnav').each(function() {
		var $subnav = $(this);
		var element = pk.element('s');
		if (!element) {
			return;
		}
		element.on('initSwitchSync', function(param) {
			var newRootArguments = param.location.param._kk._arg || {};
			var catchPathLevel = element.pathLevel() + 1; // category + project title
			var subPath = newRootArguments[catchPathLevel];
			var atSub = typeof(subPath) !== 'undefined';
			if (!atSub) { // Switch to index
				if ($subnav.is('.atSub')) {
					$subnav.addClass('atIndexInit');
					$subnav.addClass('atIndex');
					$subnav.removeClass('atSub');
					$subnav.width();
					$subnav.addClass('atIndexTransitOut');
					$subnav.removeClass('atIndexInit');
					element.one('switchSync', function() {
						$subnav.addClass('atIndexTransitIn');
						$subnav.width();
						$subnav.removeClass('atIndexTransitOut');
						transitionend($subnav[0], function() {
							$subnav.removeClass('atIndexTransitIn');
						});
					});
				}
			} else { // Switch to sub-section
				if ($subnav.is('.atIndex')) {
					$subnav.addClass('atSub');
					$subnav.addClass('atSubInit');
					$subnav.removeClass('atIndex');
					$subnav.width();
					$subnav.addClass('atSubTransitOut');
					$subnav.removeClass('atSubInit');
					element.one('switchSync', function() {
						$subnav.addClass('atSubTransitIn');
						$subnav.width();
						$subnav.removeClass('atSubTransitOut');
						transitionend($subnav[0], function() {
							$subnav.removeClass('atSubTransitIn');
						});
					});
				}
			}
		});
	});
});

// Video Ui
pk.on('loadedState', function(param, state) {
	state.$find('.videoContainer').each(function() {
		var $videoContainer = $(this);
		var $ui = $videoContainer.find('.videoUi');
		var $progress = $ui.find('.progress');
		var $progressBar = $progress.find('.progressBar');
		var $video = $videoContainer.find('video');
		var video = $video[0];
		var hoverTimer;
		var progressFrame;
		var hasStarted = false;

		state.on('attached', function() {
			$ui.on('click', playPause);
			$ui.on('click', '.muteUnmute', muteUnmute);
			$ui.on('mousedown', '.progress', progressMousedown);
			$ui.on('mousemove mousedown', checkHover);
			$ui.on('click', '.progress', false);
			//$video.on('playing pause seeked', updateProgress);
			$video.on('timeupdate', updateProgress);
			$video.on('play pause', updatePlayPause);
			$video.on('volumechange', updateMuteUnmute);
			updateMuteUnmute();
			updatePlayPause();
		});
		state.on('detached', function() {
			$ui.off('click', playPause);
			$ui.off('click', '.muteUnmute', muteUnmute);
			$ui.off('mousedown', '.progress', progressMousedown);
			$ui.off('mousemove mousedown', checkHover);
			$ui.off('click', '.progress', false);
			$video.off('play pause', updatePlayPause);
			$video.off('volumechange', updateMuteUnmute);
		});

		function checkHover() {
			if (hoverTimer) {
				clearTimeout(hoverTimer);
			} else {
				$ui.addClass('hover');
			}
			hoverTimer = setTimeout(function() {
				$ui.removeClass('hover');
				hoverTimer = undefined;
			}, 1500);
		}

		function playPause(e) {
			if (video.paused) {
				video.play();
				startProgress();
				if (!hasStarted) {
					hasStarted = true;
					$ui.addClass('hasStarted');
				}
			} else {
				video.pause();
				stopProgress();
			}
			e.stopPropagation();
		};

		function muteUnmute(e) {
			if (video.muted) {
				video.muted = false;
			} else {
				video.muted = true;
			}
			if (e) {
				e.stopPropagation();
			}
		};

		function startProgress() {
			if (!progressFrame) {
				progressFrame = requestAnimationFrame(updateProgress);
			}
		};
		function stopProgress() {
			if (progressFrame) {
				cancelAnimationFrame(progressFrame);
			}
		}

		function progressMousedown(e) {
			var $progress = $(this);
			var progressWidth = $progress.width();
			var progressOffset = $progress.offset();
			var videoDuration = video.duration;
			function update(e) {
				var value = (e.pageX-progressOffset.left)/progressWidth;
				value = Math.min(1, Math.max(0, value)); // Avoid rounding errors etc
				video.currentTime = videoDuration * value;
			}
			update(e);
			$window.on('mousemove', update);
			$window.one('mouseup', function() {
				$window.off('mousemove', update);
			});
			if (e) {
				e.stopPropagation();
			}
		};

		function updatePlayPause() {
			if (video.paused) {
				$ui.addClass('paused');
			} else {
				$ui.removeClass('paused');
			}
		}

		function updateMuteUnmute() {
			if (video.muted) {
				$ui.addClass('muted');
			} else {
				$ui.removeClass('muted');
			}
		}

		var previousPos;
		function updateProgress() {
			var currentPos;
			var duration = video.duration || 0;
			if (duration) {
				currentPos = (video.currentTime / video.duration);
			} else {
				currentPos = 0;
			}
			$progressBar.css({
				transition: (previousPos && previousPos > currentPos) ? 'width 0s' : 'width .1s',
				width: (currentPos*100) + '%'
			});
			if (previousPos && previousPos > currentPos) {
				$progressBar.width();
			}
			previousPos = currentPos;
			setTimeout(function() {
				progressFrame = requestAnimationFrame(updateProgress);
			}, 90);
		}
	});
});


// Scroll slideshows
$body.on('touchstart', '.grid.slideshow', function(e) {
	var $grid = $(this);
	var $pane = $grid.find('.gridPane');
	var grid: Grid = $grid.data('grid');
	var state = grid._state;
	var currentPosition = grid._currentLayout;
	var moved = false;
	var points: {
    t: number,
    pageX: number,
    pageY: number
   }[] = [];
	var x = currentPosition.translateX || 0;
	var y = currentPosition.translateY || 0;
	var maxScrollX = -currentPosition.width;
	var maxScrollY = -currentPosition.height;
	var enableY = 0;
	var enableX = 1;

	if (currentPosition.itemList.length > 0) {
		var lastItem = currentPosition.itemList[currentPosition.itemList.length-1];
		maxScrollX -= lastItem.css.width;
		maxScrollY -= lastItem.css.height;
	}

	$pane.css('transition', 'all 0s');
	$pane.css({
		transform: 'translateX(' + x + 'px) translateY(' + y + 'px) translateZ(0)',
		left: 0,
		top: 0
	});

	move(e);

	function move(e) {
		var point = e.originalEvent.touches[0];
		points.push({
			t: new Date().getTime(),
			pageX: point.pageX,
			pageY: point.pageY
		});

		if (points.length > 1) {
			var currentPoint = points[points.length-1];
			var previousPoint = points[points.length-2];
			var diffX = currentPoint.pageX - previousPoint.pageX;
			var diffY = currentPoint.pageY - previousPoint.pageY;

			// Slow down outside boundaries
			var newX = x + diffX;
			if (newX > 0 || newX < maxScrollX) {
				x = x + diffX/3;
			} else {
				x = newX;
			}
			var newY = y + diffY;
			if (newY > 0 || newY < maxScrollY) {
				y = y + diffY/3;
			} else {
				y = newY;
			}
			x *= enableX;
			y *= enableY;
		}

		if (points.length > 2) {
			setPosition();
			moved = true;
		}

		if (moved) {
			e.preventDefault();
			e.stopPropagation();
			return false;
		}
	};

	function setPosition() {
		$pane.css('transform', 'translateX(' + x + 'px) translateY(' + y + 'px) translateZ(0)');
	};

	function end(e) {
		// Find velocity
		var time = new Date().getTime();
		var compare1 = points[points.length-1];
		var compare2;
		for (var i=points.length-3; i>=0; i--) {
			var timeDiff = time - points[i].t; 
			if (timeDiff > 300) {
				break;
			}
			compare2 = points[i];
		}
		var distanceX = compare2 ? (compare1.pageX-compare2.pageX) : 0;
		var distanceY = compare2 ? (compare1.pageY-compare2.pageY) : 0;
		var timeDiff = compare2 ? (compare1.t - compare2.t) : 100;
		var velocity = distanceX / timeDiff;

		// Find snap position
		var snapX: number;
		var snapY: number;
		var futureX = x + velocity * 200;
		var futureY = y + velocity * 200;
		futureX *= enableX;
		futureY *= enableY;

		for (var i=0; i<currentPosition.itemList.length; i++) {
			var item = currentPosition.itemList[i];
			if (typeof(snapX) === 'undefined' || Math.abs(-futureX-item.css.left) < Math.abs(-futureX+snapX)) {
				snapX = -item.css.left;
			}
			if (typeof(snapY) === 'undefined' || Math.abs(-futureY-item.css.top) < Math.abs(-futureY+snapY)) {
				snapY = -item.css.top;
			}
		}

		var bezier;
		if (Math.abs(velocity) > 5) {
			bezier = 'cubic-bezier(0.34, 1.56, 0.64, 1)';
		} else {
			bezier = 'cubic-bezier(0.25, 1, 0.5, 1)';
		}
		var transforms = [];
		if (enableX) {
			transforms.push('translateX(' + snapX + 'px)');
		}
		if (enableY) {
			transforms.push('translateY(' + snapY + 'px)');
		}
		transforms.push('translateZ(0)');

		$pane.css({
			transition: 'transform .3s ' + bezier,
			transform: transforms.join(' ')
		});
		transitionend($pane[0], function() {
			$pane.css({
				transition: 'all 0s',
				transform: '',
				left: snapX,
				top: snapY
			});
			$pane.width();
			$pane.css('transition', '');
			currentPosition.translateX = snapX;
			currentPosition.translateY = snapY;
		});


		$body.off('touchmove', move);
		$body.off('touchend', end);
		if (moved) {
			e.stopPropagation();
			e.preventDefault();
			return false;
		}
	};

	$body.on('touchmove', move);
	$body.one('touchend', end);
});


// Head snapping
(function() {
  pk.on('loadedState', function(param, state) {
    state.$find('.siteHead.dummy').each(function() {
      let $headerDummy = $(this);
      let headerDummy = $headerDummy[0];
      $headerDummy.closest('#inverter').addClass('headerReady');

      function snap() {
        $body.removeClass('atHeader');
      }
      function unsnap() {
        $body.addClass('atHeader');
      }
      if ('IntersectionObserver' in window) {
        let headerObserver = new IntersectionObserver(function(entries, observer) {
          entries.forEach(function(entry) {
						// If entry is hidden, something is wrong (CSS) and it should be corrected shortly
						if (entry.boundingClientRect.width <= 0) {
							return;
						}
            if (entry.intersectionRatio > 0) {
              unsnap();
            } else {
              snap();
            }
          });
        }, {
          //rootMargin: "-50px -50px -50px -50px",
          threshold: [0]
        });
        headerObserver.observe(headerDummy);
      } else {
        let headerHeight: number | undefined;
        let snapped: boolean | undefined;
        let resize = () => {
          headerHeight = $headerDummy.height();
        };
        let scroll = () => {
          let scrollTop = $window.scrollTop();
          if (scrollTop > headerHeight && snapped !== true) {
            snapped = true;
            snap();
          } else if (scrollTop <= headerHeight && snapped !== false) {
            snapped = false;
            unsnap();
          }
        };
        let throttledResize = throttle(resize);

        state.on('attached', function() {
          pk.on('scroll', scroll);
          pk.on('resize', throttledResize);
          throttledResize();
          scroll();
        })
        state.on('detached', function() {
          pk.off('scroll', scroll);
          pk.off('resize', throttledResize);
        });
      }

    });
  });
})();


// Maps
pk.on('loadedState', function(param, state) {
	const $map = state.$find('.fragment.map');
	if ($map.length > 0) {
		Map.init($map, state);
  }
});


// Zoomable galleries
const scrollKeys = { 33: true, 34: true, 38: true, 40: true }; // PgUp PgDown Up Down

function preventDefault(e) {
  e.preventDefault();
  return false;
}
function preventDefaultKey(e) {
  if (scrollKeys[e.which]) {
    e.preventDefault();
    return false;
  }
}

function disableScroll() {
	window.addEventListener('wheel', preventDefault, { passive: false });
	window.addEventListener('mousewheel', preventDefault, { passive: false });
	window.addEventListener('touchmove', preventDefault, { passive: false });
	window.addEventListener('keydown', preventDefaultKey);
}

function enableScroll() {
	window.removeEventListener('wheel', preventDefault);
	window.removeEventListener('mousewheel', preventDefault);
	window.removeEventListener('touchmove', preventDefault);
  window.removeEventListener('keydown', preventDefaultKey);
}

function calculateContainPosition(imageWidth: number, imageHeight: number, containerWidth: number, containerHeight: number, targetMarginX: number, targetMarginY: number) {
  let targetWidth: number;
  let targetHeight: number;
  if (imageWidth / imageHeight > containerWidth / containerHeight) {
    targetWidth = containerWidth;
    targetHeight = targetWidth / (imageWidth / imageHeight);
  } else {
    targetHeight = containerHeight;
    targetWidth = targetHeight * (imageWidth / imageHeight);
  }
  return {
    width: targetWidth,
    height: targetHeight,
    left: (containerWidth - targetWidth) / 2 + targetMarginX,
    top: (containerHeight - targetHeight) / 2 + targetMarginY
  };
}

$body.on('click', '.zoomable:not(.zoomed)', function() {
	//const item = this;
  const $item = $(this);
  const $grid = $item.closest('.grid');
  const $margin = $item.closest('.margin');
  const grid: Grid = $grid.data('grid');
  const itemOffset = $item.offset();
  const targetMarginX = parseFloat($margin.css('marginLeft') || '0');
  const targetMarginY = parseFloat($margin.css('marginTop') || '0');
  const targetContainerWidth = $window.width() - (2*targetMarginX);
  const targetContainerHeight = $window.height() - (2*targetMarginY);
  const itemWidth = $item.width();
  const itemHeight = $item.height();
  const itemNo = $item.index();
  const item = grid._currentLayout.itemList[itemNo];
  $item.css({
		transition: 'all 0s',
    position: 'fixed',
    top: itemOffset.top - $window.scrollTop(),
    left: itemOffset.left - $window.scrollLeft(),
    width: $item.width(),
    height: $item.height(),
    zIndex: 1
  });
  $item.width();
  $item.addClass('zoomed');
  $body.addClass('zoomed');
  $body.addClass('zoomInit');
  $body.width();
  $body.removeClass('zoomInit');
  $item.css({
    transition: 'all .5s cubic-bezier(0.16, 1, 0.3, 1)',
  	...calculateContainPosition(itemWidth, itemHeight, targetContainerWidth, targetContainerHeight, targetMarginX, targetMarginY)
	});
  transitionend($item[0], function() {
    pk.trigger('resizeImages');
  });
  window.history.pushState(null, null, window.location.href);

  disableScroll();
  $window.one('popstate', close);
  $body.one('click', back);
  $body.on('keydown', checkKeyPress);
  
  function back() {
    window.history.back();
  };

  async function close() {
    $body.off('click', back);
    $body.off('keydown', checkKeyPress);

    $body.addClass('zoomEnd');
    $body.removeClass('zoomed');

    $item.css({
      width: itemWidth,
      height: itemHeight,
      top: itemOffset.top - $window.scrollTop(),
      left: itemOffset.left - $window.scrollLeft()
    });

    let promises: Promise<void>[] = [];
    promises.push(transitionend($item[0]));
    promises.push(transitionend($body[0]));

    await Promise.all(promises);

    $item.css({
      position: 'absolute',
      transition: '',
      zIndex: ''
    });
    $item.css(item.css);
    $item.removeClass('zoomed');
    enableScroll();

    $body.removeClass('zoomEnd');
  };

  function checkKeyPress(e) {
    if (e.which === 37) {
      previous();
    } else if (e.which === 39) {
      next();
    } else if (e.which === 27) {
      close();
    }
  }

  async function previous() {
    const $previous = $item.prev();
    if ($previous.length > 0) {
      await close();
      $previous.trigger('click');
    }
  }
  async function next() {
    const $next = $item.next();
    if ($next.length > 0) {
      await close();
      $next.trigger('click');
    }
  }
});

